import { useContext, useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { SmartContext } from '../../../../library/Core/SmartContext';
import AlumniPostGradCardControl from '../../../card-controls/AlumniPostGradCardControl';
import CarouselComponent from '../../../card-controls/CarouselComponent';
import SessionContext from '../../../../library/Core/SessionContext';
import { allowPerformAction, getActionElementClass, getDomainValueForCode, isEmpty, isSchoolAdmin } from '../../../../library/Core/SmartFunctions';
import ExpandableDescription from '../controls/ExpandableDescription';

const ProfileDoctoral = () => {
    const { state, dispatch } = useContext(SmartContext);
    const { sessionState } = useContext(SessionContext);

    const model = state.internal.model;
    const navigate = useNavigate();

    const [isActive, setIsActive] = useState(false);
    const [isHidden, setIsHidden] = useState(false);

    const [actionBtnStatus, setActionBtnStatus]: any = useState({});

    const doctoralColleges = (model?.postGradColleges ?? []).filter((college: any) => college?.isPhd === true);

    const handleClick = (id: any) => {
        setIsActive(!isActive);
        setIsHidden(!isHidden);

        setActionBtnStatus({
            ...actionBtnStatus,
            [id]: !actionBtnStatus[id],
        });
    };

    useEffect(() => {
        const interval = setInterval(() => {
            const owlNextElement = document.getElementsByClassName('owl-next')[0] as HTMLDivElement;
            if (owlNextElement) {
                owlNextElement.click();
            }
        }, 5000);

        return () => {
            clearInterval(interval);
        };
    }, []);

    return (
        <div>
            <div className="tab-pane fade active show" id="pills-doctoral" role="tabpanel" aria-labelledby="pills-doctoral-tab">
                <div className="postGraduate-detail">
                    <div className="blockHeader">
                        <div className="row g-2  align-items-center">
                            <div className="col">
                                {!model.isEditable && (
                                    <div className="title">
                                        Doctoral College(s) of{' '}
                                        <span>
                                            {`${model.firstName}`} {model.lastName ? `${model.lastName}` : ''}
                                        </span>
                                    </div>
                                )}
                                {model.isEditable && <div className="title">My Doctoral College(s)</div>}
                            </div>
                            {model.isEditable && (
                                <div className="col-auto">
                                    <a role="button"
                                        className={`btn-add-section ${getActionElementClass()}`}
                                        onClick={() => {
                                            if (allowPerformAction()) {
                                                navigate(`/alumni/${model.id}/pg`);
                                            }
                                        }}>
                                        <i></i> <span>ADD</span>
                                    </a>
                                </div>
                            )}
                        </div>
                    </div>
                    {doctoralColleges.length === 0 ? (
                        <div className="empty-state">
                            <p>No Doctoral details added yet</p>
                        </div>
                    ) : (
                        doctoralColleges.map((college: any) => (
                            <div key={college.universityId + college.universityName} className="graduateRow edit">
                                <div className="college_detail_wrap">
                                    <div className="college_detail">
                                        <div className="college_logo">
                                            <a
                                                className=""
                                                href="javascript:void(0)"
                                                rel="noopener noreferrer"
                                                style={{ cursor: 'default' }}>
                                                <img
                                                    className="img-fluid"
                                                    width="80"
                                                    height="80"
                                                    src={`${college.logoFileName}`}
                                                    alt="No Image"
                                                />
                                            </a>
                                        </div>
                                        <div className="college_name_scholarship">
                                            <div className="college_name">
                                                <a
                                                    href="javascript:void(0)"
                                                    rel="noopener noreferrer"
                                                    style={{ textDecoration: 'none', cursor: 'default' }}>
                                                    <h3>{college.universityName}</h3>{' '}
                                                </a>
                                                <p>
                                                    {college.cityName && `${college.cityName},`} {college.stateName && `${college.stateName},`}{' '}
                                                    {college.countryName}
                                                    {(college.startYear || college.endYear) &&
                                                        ` | ${[college.startYear, college.endYear].filter((y) => y != null && y !== '').join(' - ')}`}
                                                </p>
                                                {college.description && <ExpandableDescription text={college.description} />}
                                                <div className="alumni_profile_college_subject">
                                                    <i className="icon"></i>
                                                    {college.fieldOfStudy === '1' ? (
                                                        <span>
                                                            {getDomainValueForCode(
                                                                college.fieldOfStudy,
                                                                'FIELD_OF_STUDY_TYPE_CODE_ALUMNI',
                                                                state
                                                            )}
                                                        </span>
                                                    ) : (
                                                        <span>{college.fieldOfStudy}</span>
                                                    )}
                                                </div>
                                            </div>
                                            {!isEmpty(college?.scholarship) ? (
                                                <div className="scholarship">
                                                    <span className="scholarship_label">Scholarship</span>
                                                    <span className="scholarship_amt">{college.scholarship}</span>
                                                </div>
                                            ) : (
                                                ''
                                            )}
                                        </div>
                                    </div>
                                </div>
                                <div className="offer offer_edit">
                                    <div className="offer_existing_links">
                                        {college.recordTypeCode === 'JOINED' && (
                                            <a className="joindeLink">
                                                <i className="icon-like"></i> <span>{college.recordTypeCode}</span>
                                            </a>
                                        )}
                                        {college.collegeApplicationResultCode === 'GOT_OFFER_DID_NOT_JOIN' && (
                                            <div className="got_offer">
                                                <i className="icon-like"></i>
                                                <span>Got Offer but did not join</span>
                                            </div>
                                        )}
                                        {college.collegeApplicationResultCode === 'NO_OFFER' && (
                                            <div className="got_offer">
                                                <span>Did not get offer</span>
                                            </div>
                                        )}
                                    </div>
                                    {model.isEditable && (
                                        <div className={`edit_section ${actionBtnStatus[college.universityId] ? 'open' : ''} ${isHidden ? 'hidden' : ''}`}>
                                            <button className="edit_section_toggle" onClick={() => { handleClick(college.universityId) }}></button>
                                            <div className="edit_section_inner">
                                                <a role="button"
                                                    className={`edit_link ${getActionElementClass()}`}
                                                    onClick={() => {
                                                        if (allowPerformAction()) {
                                                            navigate(`/alumni/${model.id}/pg`);
                                                        }
                                                    }}>
                                                    Edit
                                                </a>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            </div>
                        ))
                    )}
                </div>
                {state.data?.matchingAlumni?.data && state.data?.matchingAlumni?.data.length > 0 && (
                    <div className="graduation_carousel_wrap">
                        <CarouselComponent
                            key={'DoctoralAlumni'}
                            data={state.data?.matchingAlumni?.data}
                            cardRenderer={AlumniPostGradCardControl}
                            itemsPerPage={4}
                            itemsPerSlide={2}
                            responsive={{
                                0: { items: 1 },
                                400: { items: 1 },
                                600: { items: 2 },
                                700: { items: 2 },
                                1000: { items: 2 },
                            }}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};

export default ProfileDoctoral;
